import { IMicrosite } from "../app/models/microsite";

export const microsites: IMicrosite[] = [
  {
    name: "Logger",
    entrypoint: "/logger",
    host: "https://console.hhs.ithdev.com/ui/logger",
    displayName: "Log Service",
  },
  {
    name: "Monitoring",
    entrypoint: "/monitoring",
    host: "https://console.hhs.ithdev.com/ui/monitoring",
    displayName: "Monitoring",
  },
  {
    name: "Updater",
    entrypoint: "/updater",
    host: "https://console.hhs.ithdev.com/ui/updater",
    displayName: "Updater",
  },
  {
    name: "DeviceProvisioning",
    entrypoint: "/provisioning",
    host: "https://console.hhs.ithdev.com/ui/provisioning",
    displayName: "Device Provisioning",
  },
  {
    name: "AccessManagement",
    entrypoint: "/access",
    host: "https://console.hhs.ithdev.com/ui/access",
    displayName: "Access Management",
  },
  {
    name: "PASProvisioning",
    entrypoint: "/pas-provisioning",
    host: "https://console.hhs.ithdev.com/ui/pas-provisioning",
    displayName: "PAS Provisioning",
  },
  {
    name: "AuxUpdater",
    entrypoint: "/auxupdater",
    host: "https://console.hhs.ithdev.com/ui/auxupdater",
    displayName: "Aux Updater",
  },
  {
    name: "ITLLogViewer",
    entrypoint: "/itl-log-viewer",
    host: "https://console.hhs.ithdev.com/ui/itl-log-viewer",
    displayName: "ITL Log Viewer",
  },
];
